import actionTypes from '../constants/action-types';

function usedCustomColors(state = {}, action) {
  switch (action.type) {
    case actionTypes.ADD_USED_CUSTOM_COLOR: {
      const { pageId, color } = action.payload;
      const { usedCustomColors = [] } = state;

      if (state.id !== pageId || usedCustomColors.includes(color)) return state;

      return {
        ...state,
        usedCustomColors: [...usedCustomColors, color],
      };
    }

    case actionTypes.DELETE_USED_CUSTOM_COLOR: {
      const { pageId, color } = action.payload;
      const { usedCustomColors = [] } = state;

      if (state.id !== pageId || !usedCustomColors.includes(color)) return state;

      return {
        ...state,
        usedCustomColors: usedCustomColors.filter((usedColor) => usedColor !== color),
      };
    }

    default:
      return state;
  }
}

export default usedCustomColors;
